import moment, { Moment } from 'moment'
export const requestDateFormat = 'YYYY-MM-DD'
export const requestTimeFormat12 = 'hh:mm A'

export const requestMonthFormat = 'MMM YYYY'
export const allFormatDate = 'YYYY-MM-DD HH:mm:ss Z'

export const weekdayAndDateFormat = 'ddd L'
export const hoursMinutesFormat = 'LT'
export const datepickerMonthFormat = 'YYYY-MM'

export const convertDateToRequestFormat = (date: Moment, format?: string) =>
  moment(date, format).format(requestDateFormat)

export const getQuarterAndYear = (data: Moment) => {
  const [year, quarter] = moment(data).format('YYYY-Q').split('-')
  return { year, quarter }
}

export const getPeriodFromQuarterAndYear = (
  year?: string,
  quarter?: string
) => {
  const yearNumber = Number(year)
  const quarterNumber = Number(String(quarter ?? '').replace(/\D/g, ''))

  if (!yearNumber || quarterNumber < 1 || quarterNumber > 4) return null

  return moment().year(yearNumber).quarter(quarterNumber).startOf('quarter')
}

export const getPeriodFromPeriodEnding = (periodEnding?: string | null) => {
  if (!periodEnding) return null

  const date = moment(periodEnding)
  if (!date.isValid()) return null

  return date.startOf('quarter')
}

export const getCompletedQuarter = () => moment().subtract(1, 'quarter')

export const getCompletedMonth = () => moment().subtract(1, 'month')

export const getCompletedYear = () => moment().subtract(1, 'year')
